module.exports = __webpack_public_path__ + "static/media/shopping-basket.0f8b5e8a.svg";